import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { SLAKPIApiService } from '../../../services/slakpi.service';
import { BMApiService } from '../../../services/bm.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, kpiViewComment, recentUpdates, surveyConfig } from '../../../models/slakpi';
import { division } from '../../../models/admin';
import { ToasterService } from '../../../toaster.service';

//import * as xml2js from 'xml2js';
import { NewsRss } from '../../../models/news-rss';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-bench-mark-home',
  templateUrl: './bench-mark-home.component.html',
  styleUrls: ['./bench-mark-home.component.css']
})
export class BenchMarkHomeComponent implements OnInit {
  RssData: any=[];
  tenantUno: any;
  recentUpdate_data: any;
  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean;

  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  noDataImg: any;
    
    SurveyLink: string;
  EnableSurveyLink: string = '0';
  BMRequestLink: string;
  constructor(public restApiBM: BMApiService, public restAdminApi: AdminApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService, private http: HttpClient) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.tenantUno = this.user.tenantUno;
    this.noDataImg = this.utilityService.getnodataImage();
    this.ValidateUserAccess();
    this.loadSurveyConfig();
  }
  ValidateUserAccess() {
    
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    //if (!this.isAdmin) {
    //  let userPermissionData = this.userService.getUserRights("Awarness Session");
    //  if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
    //    if (userPermissionData[0].showPage == 1) {

    //    }
    //    else {
    //      this.router.navigateByUrl('/access-denied');
    //    }
    //  }
    //}

  }
  loadSurveyConfig() {
    
    let inpValue = new surveyConfig();
    inpValue.enableSurveyLink = "";
    inpValue.surveyLink = "";
    inpValue.bmRequestLink = "";
    inpValue.userUno = this.login_UserID;
    this.restApiBM.getSurveyConfig(inpValue)
      .subscribe(data => {
        
        let rtnData: surveyConfig;
        rtnData = data;
        this.EnableSurveyLink = rtnData.enableSurveyLink;
        this.SurveyLink = rtnData.surveyLink;
        this.BMRequestLink = rtnData.bmRequestLink;
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  ngOnInit() {
    this.userService.CheckLogin();
    this.getRecentUpdates();

    this.GetRssFeedData();
  }
  getRecentUpdates() {

    let inpValue = new recentUpdates();
    
    inpValue.userUno = this.login_UserID;
    inpValue.condition = 1;
    this.restApiBM.getRecentUpdated(inpValue)
      .subscribe(data => {

        this.recentUpdate_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  //GetRssFeedData() {
  //  const requestOptions: Object = {
  //    observe: 'body',
  //    responseType: 'text'
  //  };
  //  this.http
  //    .get<any>('https://www.apqc.org/blog/rss.xml', requestOptions)
  //    .subscribe(data => {
  //      let parseString = xml2js.parseString;
  //      parseString(data, (err, result: NewsRss) => {
  //        
  //        this.RssData = result;
  //      });
  //    });
  //}

  GetRssFeedData() {
    let inpValue: any = {};
    inpValue.userUno = this.login_UserID;
    this.restApiBM.getRssFeed(inpValue)
      .subscribe((data: any) => {
        //
        if (data != undefined && data != null && data != '') {
          let item = data.rss.channel.item;
          this.RssData = item.slice(0, 5);
        }
        
       
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
   
  }

}
export interface IRssData { }
